/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StandingAll = {
    properties: {
        standings: {
            type: 'dictionary',
            contains: {
                type: 'StandingSmallList',
            },
        },
        league: {
            type: 'League',
            isRequired: true,
        },
    },
} as const;
